// Module
var code = `
<div class="passwordContainer">

    <terceraTextBox inputType="{{passwordHided ? 'password' : 'text'}}"
                    visible="{{visible}}"
                    name="{{name}}"
                    haveError="{{haveError}}"
                    text="{{text}}"
                    enabled="{{enabled}}"
                    focused="{{focused}}"
                    autofocus="{{autofocus}}"
                    tooltip="{{tooltip}}"
                    placeholder="{{placeholder}}"
                    elementStyle="{{elementStyle}}"
                    isMaterialDesign="{{isMaterialDesign}}"/>

    <terceraButton name="{{passwordHided ? 'showPassEye' : 'hidePassEyeCrossed'}}"
                    visible="{{showPasswordPreview}}"
                    tooltip="{{passwordHided ? showPassEyeTooltip : hidePassEyeCrossedTooltip}}"
                    terceraButtonStyle="passwordPreviewEye"
                    SVG="true"
                    on-btnHover="showPassEye_btnHover"
                    on-btnClick="showPassEye_btnClick" />

</div>`;
// Exports
export default code;